import { Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AccountService } from 'src/app/services/auth';
import { MenuService } from 'src/app/services/menu/menu-service';
import { Constantes } from 'src/app/shared/Constantes/constantes';
import { OrderService } from 'src/app/services/pedidos/pedidos.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ModalConfirmarCerrarSessionComponent } from './modal-confirmar-cerrar-session.component';
import { ModalInfoComponent } from 'src/app/shared/modal-info/modal-info.component';
import { Notificacion, NotificacionGroup, NotificacionService } from 'src/app/services/notificaciones/notificaciones.service';
import { OfflineStorageService } from 'src/app/services/offline/offline-storage.service';
import { CacheWarmupService } from 'src/app/services/offline/cache-warmup.service';
import { SyncService } from 'src/app/services/offline/sync.service';
import { ExecutionContextService } from 'src/core/context/execution-context.service';
import { ProfileNavigationKey } from 'src/core/navigation/profile-navigation.types';
import { ProfileNavigationService } from 'src/core/navigation/profile-navigation.service';

@Component({
    selector: 'app-authenticated-shell',
    templateUrl: './authenticated-shell.component.html',
    styleUrls: ['./authenticated-shell.component.css'],
    standalone: false
})
export class AuthenticatedShellComponent implements OnInit, OnDestroy {
  isMixer = false;
  statusCss = '';
  isOnline = true;
  queueCount = 0;
  showOfflineToast = false;
  private onlineSub: Subscription;
  private queueCountSub: Subscription;
  private offlineToastTimer: any;
  @ViewChild('modalCerrarSesion', { static: true }) modalCerrarSesion!: ModalConfirmarCerrarSessionComponent;
  @ViewChild('modalInfo', { static: true }) modalInfo!: ModalInfoComponent;
  notificacionesAgrupadas: NotificacionGroup[] = [];
  showNotifications: boolean = false;
  isCollapsed = false;
  active = '';
  userName = '';
  currentComponent: string = '';
  modalTitle: string = '';
  modalMessage: string = '';
  buttonText: string = '';
  isSidebarOpen = false;
  /** Cualquier ruta bajo control de combustible (listado o formulario): shell móvil por debajo de lg. */
  isControlCombustibleSection = false;
  /** Ruta de formulario de combustible: Atrás en barra de título desktop. */
  isControlCombustibleFormulario = false;
  /** Detalle firma digital / guía papel: el page ya trae su título. */
  isFirmaDigitalDetalle = false;
  private lastNavigationPath = '';

  private readonly navModules: Record<string, { label: string }> = {
    dashboard: { label: 'Dashboard' },
    checklist: { label: 'Check list' },
    despacho: { label: 'Despacho actual' },
    otrosdespachos: { label: 'Otros despachos' },
    historial: { label: 'Historial' },
    fatiga: { label: 'Fatiga' },
    combustible: { label: 'Control de combustible' },
  };

  constructor(
    public menuService: MenuService,
    private accountService: AccountService,
    private router: Router,
    private pedidosService: OrderService,
    private notificacion: NotificacionService,
    private offlineStorage: OfflineStorageService,
    private cacheWarmup: CacheWarmupService,
    private syncService: SyncService,
    private ngZone: NgZone,
    private readonly executionContext: ExecutionContextService,
    private readonly profileNavigation: ProfileNavigationService


  ) {
    if (menuService.paginaPrevius == undefined) {
      menuService.paginaPrevius = '/dashboard';
    }
    this.accountService.user.subscribe((user) => {
      if (!user) return;
      const context = this.executionContext.getAuthenticated();
      this.isMixer = context?.role === 'mixer';
      this.statusCss = this.getStatus();
    });


    this.router.events.subscribe(() => {
      const url = this.router.url.toLowerCase();

      switch (true) {
        case url.includes('otrosdespachos'):
          this.active = 'otrosdespachos';
          break;

        case url.includes('pedidospendiente'):
          this.active = 'despacho';
          break;

          case url.includes('checklist'):
          this.active = 'checklist';
          break;

          case url.includes('fatiga'):
          this.active = 'fatiga';
          break;

         case url.includes('pedidosentregados'):
           this.active = 'historial';
           break;

           case url.includes('dashboard'):
           this.active = 'dashboard';
           break;

           case url.includes('controlcombustible'):
        this.active = 'combustible';
        break;

           case url.includes('hormigon-operador-planta/cierre-diario'):
        this.active = 'cierre-diario';
        break;

      /*
         default:
           this.active = '';
           break; */
      }
    });





  }
  clasModalCall = Constantes.classCierreModal;
  clasModalPerfil = Constantes.classCierreModal;
  classModalCerrarSession = Constantes.classCierreModal;


  ngOnInit(): void {
    this.userName = this.formatName(
      this.accountService.userValue.NOMBRE_USUARIO.split(' ')[0] +
      ' ' +
      this.accountService.userValue.NOMBRE_USUARIO.split(' ')[1]
    );

    const initialUrl = this.router.url;
    const cleanUrl = initialUrl.split('?')[0];
    const initialParts = cleanUrl.split('/').filter(Boolean);
    this.currentComponent = initialParts[0] || '';
    this.updateCombustibleRouteFlags(initialUrl);
    this.updateFirmaDigitalRouteFlags(initialUrl);
    this.setTitle(this.currentComponent);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const parts = event.urlAfterRedirects.split('/').filter(Boolean);
        this.currentComponent = parts[0] || '';
        this.updateCombustibleRouteFlags(event.urlAfterRedirects);
        this.updateFirmaDigitalRouteFlags(event.urlAfterRedirects);
        this.setTitle(this.currentComponent);
        // Solo refrescar listado/PDFs de viajes al entrar a pantallas que los usan.
        const path = event.urlAfterRedirects.split('?')[0];
        const pathChanged = path !== this.lastNavigationPath;
        this.lastNavigationPath = path;
        if (pathChanged && this.isViajesRelatedRoute(event.urlAfterRedirects)) {
          this.cacheWarmup.forceWarmUp();
        }
        // Drenar cola offline en cualquier navegación (firmas, rechazos, etc.).
        this.syncService.flushNow();

        this.isSidebarOpen = false;

      });

    window.triggerCacheWarmup = () => {
      this.ngZone.run(() => {
        this.cacheWarmup.warmUp();
        // App-resume is also a good moment to drain the queue — the driver may have
        // signed something right before the tablet slept and come back expecting it sent.
        this.syncService.flushNow();
      });
    };


    this.cargarNotificaciones();

    this.isOnline = this.offlineStorage.isOnline();
    this.onlineSub = this.offlineStorage.online$.subscribe(online => {
      this.isOnline = online;
    });
    this.queueCountSub = this.offlineStorage.queueCount$.subscribe(n => {
      this.queueCount = n;
    });

    this.cacheWarmup.init();
  }

  get canShowNotifications(): boolean {
    return this.executionContext.getAuthenticated()?.role !== 'operador-planta';
  }

  canShowNavigation(key: ProfileNavigationKey): boolean {
    return this.profileNavigation.isVisible(
      this.executionContext.getAuthenticated(),
      key
    );
  }

  navigationPath(key: ProfileNavigationKey): string {
    return this.profileNavigation.getPath(
      this.executionContext.getAuthenticated(),
      key
    ) ?? '/dashboard';
  }

  ngOnDestroy(): void {
    this.onlineSub?.unsubscribe();
    this.queueCountSub?.unsubscribe();
    clearTimeout(this.offlineToastTimer);
    delete window.triggerCacheWarmup;
  }

  onLockedNavClick(): void {
    clearTimeout(this.offlineToastTimer);
    this.showOfflineToast = true;
    this.offlineToastTimer = setTimeout(() => this.showOfflineToast = false, 2500);
  }

  private updateCombustibleRouteFlags(url: string): void {
    const path = url.split('?')[0].toLowerCase();
    this.isControlCombustibleSection = path.includes('controlcombustible');
    this.isControlCombustibleFormulario = path.includes('controlcombustible/formulario');
  }

  private updateFirmaDigitalRouteFlags(url: string): void {
    const path = url.split('?')[0].toLowerCase();
    this.isFirmaDigitalDetalle =
      path.includes('pedidospendiente/detalle') ||
      path.includes('otrosdespachos/detalle');
  }

  get mobileModuleLabel(): string {
    if (this.currentComponent === 'PedidosPendientes') {
      return 'Detalle de tu pedido';
    }
    return this.navModules[this.active]?.label ?? this.menuService.tilteMenu;
  }

  /** Rutas que muestran o dependen del listado de viajes/pedidos. */
  private isViajesRelatedRoute(url: string): boolean {
    const path = url.split('?')[0].toLowerCase();
    if (path.endsWith('/detalle')) return false;
    return (
      path.includes('pedidospendiente') ||
      path.includes('otrosdespachos') ||
      path.includes('pedidosentregados')
    );
  }

  /** Móvil (menor a 768px) o control combustible en tablet (menor a 992px / Bootstrap lg). */
  private usesMobileNavShell(): boolean {
    const w = window.innerWidth;
    if (w < 768) {
      return true;
    }
    return this.isControlCombustibleSection && w < 992;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (!this.usesMobileNavShell()) {
      this.isSidebarOpen = false;
    }
  }

  onCombustibleFormularioBack(): void {
    this.menuService.combustibleFormularioBackClick.next();
  }

  private cargarNotificaciones() {
    if (!this.canShowNotifications || !this.pedidosService.hasAuthKey()) {
      return;
    }
    this.notificacion.getNotificaciones(true).subscribe({
      next: (data: Notificacion[]) => {
        this.notificacionesAgrupadas = this.groupNotifications(data);
      },
      error: (err) => console.warn('Error al obtener notificaciones:', err),
    });
  }

  // Agrupa por fecha y orden
  private groupNotifications(list: Notificacion[]): NotificacionGroup[] {
    const mapFecha = new Map<string, Notificacion[]>();

    list.forEach((item) => {
      const fecha = item.fecha_orden || item.fecha;

      if (!mapFecha.has(fecha)) {
        mapFecha.set(fecha, []);
      }
      mapFecha.get(fecha)!.push(item);
    });

    for (const [fecha, arr] of mapFecha) {
      arr.sort((a, b) => {
        if (a.folio_h !== b.folio_h) {
          return a.folio_h.localeCompare(b.folio_h);
        }
        return a.orden - b.orden;
      });
    }

    return Array.from(mapFecha.entries())
      .sort((a, b) => new Date(b[0]).getTime() - new Date(a[0]).getTime())
      .map(([fecha, items]) => ({ fecha, items }));
  }

  // 👉 abrir/cerrar panel
  toggleNotifications() {
    if (!this.canShowNotifications) {
      return;
    }
    this.showNotifications = !this.showNotifications;
  }

  closeNotifications() {
    this.showNotifications = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showNotifications) {
      return;
    }
    const target = event.target as HTMLElement | null;
    // El trigger del header ya alterna el panel: ignorarlo evita cerrarlo al abrirlo.
    if (target?.closest('.notifications-panel, .notificacion')) {
      return;
    }
    this.showNotifications = false;
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.showNotifications = false;
  }

  /*   openModalCall() {
      this.clasModalCall = Constantes.classAperturaModal;
    } */
  cerrarModalCall() {
    this.clasModalCall = Constantes.classCierreModal;
  }

  openModalperfil() {
    this.clasModalPerfil = Constantes.classAperturaModal;
  }
  cerrarModalperfil() {
    this.clasModalPerfil = Constantes.classCierreModal;
  }

  cerrarModalSession() {
    this.classModalCerrarSession = Constantes.classCierreModal;
  }
  openModalCerrarSession() {
    this.modalCerrarSesion.open();
  }

  goBack() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/PedidosPendientes/Detalle')) {
      this.menuService.return.next(true);
      return;
    }
    window.history.back();
  }

  isInDashboard() {
    if (window.location.pathname == '/dashboard') return true;

    return false;
  }

  getStatus() {
    if (this.accountService.userValue.ESTADO == '1') return 'active';
    if (this.accountService.userValue.ESTADO == '0') return 'inactive';
    return 'absent';
  }

  toDashboard() {
    this.router.navigate(['/dashboard']);
  }

  toggleSidebar() {
    if (this.usesMobileNavShell()) {
      this.isSidebarOpen = !this.isSidebarOpen;
    } else if (this.isSidebarOpen) {
      this.isSidebarOpen = false;
    } else {
      this.isCollapsed = !this.isCollapsed;
    }
  }


  setActive() {
    const section = this.router.url;

    switch (section) {

      case '/dashboard':
        this.active = "dashboard";
        break;

      case '/pedidosEntregados':
        this.active = "historial";
        break;

      default:
        break;
    }




    if (this.usesMobileNavShell()) {
      this.isSidebarOpen = false;
    }
  }

  formatName(name: string): string {
    const words = name.toLowerCase().split(' ');
    const formattedName = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return formattedName.join(' ');
  }

  cerrarSession() {
    this.setStatus(0);
    this.accountService.logout();
    this.router.navigate(['login']);
    this.menuService.showModalFirstTime = true;
  }

  setStatus(status: number) {
    this.pedidosService
      .setStatus(status.toString(), this.accountService.userValue.RUT_USUARIO)
      .subscribe((response) => {
        this.accountService.updateStatus(status.toString());
        // console.log(response);
      });
  }

  openModalCall() {
    this.modalTitle = '¿Deseas contactarnos?';
    this.modalMessage = `
  Si necesitas ayuda, siempre puedes conversar con nuestro equipo de Servicio al Cliente al 600 620 6200.`;
    this.buttonText = 'Llamar'
    this.modalInfo.open();

  }


  //para cambiar si el titulo del menu es distinto al del contenedor.
  setTitle(componentName) {
    switch (componentName) {
      case 'dashboard':
        this.menuService.tilteMenu = 'Dashboard';
        break;

      case 'pedidosEntregados':
        this.menuService.tilteMenu = 'Historial de despachos'
        break;

      default:
        break;
    }

  }
}
